interface StaticUserInfoProps {
    fullName: string;
    email: string;
}

export const StaticUserInfo = ({ fullName, email }: StaticUserInfoProps) => {
    return (
        <div className="userInfoContainer form-redux">
            <div className="name-field">
                <div>Full Name*</div>
                <div>{fullName}</div>
            </div>
            <div className="email-field">
                <div>Email*</div>
                <div>{email}</div>
            </div>
        </div>
    );
};
